import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class PayoutAddMethodPersonalInfoController extends Controller {
  @service router;
  @service session;

  @action
  handleSubmitSuccess() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.SETTINGS__PAYOUT__ADD_METHOD__TRANSFER_METHOD, {
      queryParams: {
        payoutMethodId: this.model.payoutMethodId,
        countryCode: this.model.countryCode,
      },
    });
  }
}

export default PayoutAddMethodPersonalInfoController;
